import {
	useRegisterCommands,
	COMMAND_PALETTE_REGISTRY_IDS,
} from '@atlassian/jira-command-palette-registry';
import { useIssueNavigatorLink } from '../../controllers/use-issue-navigator-link';
import { useCopyPageUrlCommand } from './use-copy-page-url';
import { useNavigationCommands } from './use-navigation-commands';

export const useRegisterInitialCommands = () => {
	const copyCommand = useCopyPageUrlCommand();
	const navigationCommands = useNavigationCommands();
	const { issueNavigatorLink } = useIssueNavigatorLink();

	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.COPY_URL, [copyCommand]);
	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.NAVIGATION_COMMANDS, navigationCommands, [
		issueNavigatorLink,
	]);
};
